import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingWhatsApp() {
  const { openWhatsApp } = useSite();
  return (
    <button
      data-testid="whatsapp-floating-btn"
      onClick={() => openWhatsApp({ service: "General Inquiry" })}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 rounded-full bg-emerald-brand text-white pl-4 pr-5 py-3 shadow-[0_10px_30px_-8px_rgba(13,92,58,0.6)] hover:scale-105 transition-transform"
      aria-label="Contact us on WhatsApp"
    >
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      <MessageCircle size={22} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </button>
  );
}
